import React, { useEffect, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Academy } from './components/Academy';
import { BookingSystem } from './components/BookingSystem';
import { ColoristShowcase } from './components/ColoristShowcase';
import { About } from './components/About';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
import { PromoVideo } from './components/PromoVideo';
export function App() {
  useEffect(() => {
    // 1. SEO Title & Meta Description
    document.title = 'Barbería Ninja 2.0';
    if (!document.querySelector('meta[name="description"]')) {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Barbería Ninja 2.0 - Elevando el arte del cabello al siguiente nivel. Cortes de autor, colorimetría avanzada y formación para barberos en El Pinar, Uruguay.';
      document.head.appendChild(meta);
    }
    // 2. Preconnect to Google Fonts to resolve render-blocking warnings
    if (!document.querySelector('link[href="https://fonts.googleapis.com"]')) {
      const preconnect1 = document.createElement('link');
      preconnect1.rel = 'preconnect';
      preconnect1.href = 'https://fonts.googleapis.com';
      document.head.appendChild(preconnect1);
      const preconnect2 = document.createElement('link');
      preconnect2.rel = 'preconnect';
      preconnect2.href = 'https://fonts.gstatic.com';
      preconnect2.crossOrigin = 'anonymous';
      document.head.appendChild(preconnect2);
    }
    // 3. DNS Prefetch for CDN to speed up image/video discovery
    if (!document.querySelector('link[href="https://cdn.magicpatterns.com"]')) {
      const dnsPrefetch = document.createElement('link');
      dnsPrefetch.rel = 'dns-prefetch';
      dnsPrefetch.href = 'https://cdn.magicpatterns.com';
      document.head.appendChild(dnsPrefetch);
    }
  }, []);
  return <div className="min-h-screen w-full overflow-x-hidden bg-[#0a0a0a] text-white font-sans selection:bg-neon-violet/30 selection:text-white" data-id="element-0" data-mp="swgkxqawp4q6">
      <Navbar data-id="element-1" data-mp="3udkm1tuvgq9c" />
      <main data-id="element-2" data-mp="3ubzsa6gdtbcj">
        <Hero data-id="element-3" data-mp="3uc9inv5c9kir" />
        <BookingSystem data-id="element-4" data-mp="3uevpttobhy0g" />
        <PromoVideo data-id="element-5" data-mp="d4e5zu7z1ex8" />
        <Academy data-id="element-6" data-mp="d4xopd5g47cb" />
        <ColoristShowcase data-id="element-7" data-mp="d3cvbquvaug1" />
        <About data-id="element-8" data-mp="d2l936n5u92f" />
      </main>
      <Footer data-id="element-9" data-mp="85uj9rljzz3t" />
      <FloatingWhatsApp data-id="element-10" data-mp="851hl51gbzsj" />
    </div>;
}